<template>
    <div>
        <div class="a-flex-rfsc" v-if="!readonly">
            <le-select-remote-search v-model="ammeterInfo" isObj :options="optionsAmmeter" :disableOptions="disableAmmeter" placeholder="请选择电表(可搜索)" />
            <!-- <el-button type='primary' class="a-ml-10" @click="handleChooseAmmeter">确认添加</el-button> -->
            <el-button type='text' class="a-ml-10" @click="addElectricityMeter">没有找到电表？点击创建新电表</el-button>
        </div>
        <el-table :data="tableData" class="a-mt-10" :span-method="arraySpanMethod">
            <el-table-column label="电表站点">
                <template slot="header" >
                    <div class="a-flex-rfsc">
                        <span>电表站点</span>
                        <el-tooltip class="item" effect="dark" content="允许与其他站点共用电表。如果此处添加的电表已用于其他站点，则视为多站点共用电表" placement="top">
                            <span class="el-icon-question"></span>
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="scope">
                    <div class="a-flex-rfsfs a-flex-wrap">
                        <div class="send-user a-flex-rfsc" v-if="showMine">
                            <span class="a-c-white">本站点</span>
                        </div>
                        <div class="send-user a-flex-rfsc" v-for="(item,index) in scope.row.stationIdList" :key="index">
                            <span class="send-user-tag" v-if="item.status == 1">已转移</span>
                            <span class="a-c-white">{{ item.label }}</span>
                            <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                <i class="el-icon-close a-c-white a-ml-10" @click="handleRemoveStation(index)" v-if="item.value != stationId"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="电表号">
                <template slot-scope="{ row }">
                    <span>{{ row.ammeterNo || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="电表图片">
                <template slot-scope="{ row }">
                    <el-image v-for="(item, index) in row.meterPic" :key="index" :src="item" :preview-src-list='row.meterPic' style="width: 80px;height:80px;border-radius: 4px;margin-right: 8px"></el-image>
                    <span v-if="!row.meterPic || !row.meterPic.length">-</span>
                </template>
            </el-table-column>
            <el-table-column label="估计耗电占比">
                <template slot="header" slot-scope="scope">
                    <div class="a-flex-rfsc">
                        <span>估计耗电占比</span>
                        <el-tooltip class="item" effect="dark" content="如果一个站点有多个电表，此时各电表估算的耗电量=站点设备统计的耗电量*估计耗电占比；站点内各电表的耗电占比之和必须等于100%" placement="top">
                            <span class="el-icon-question"></span>
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="{ row }">
                    <el-input  
                        v-if="!readonly"
                        v-model="row.ratio" 
                        maxlength="50" 
                        @input="row.ratio = util.checkMoney(row.ratio)" 
                        placeholder="请输入" >
                        <template slot="append">%</template>
                    </el-input>
                    <span v-else>{{ row.ratio }}%</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="操作" width="100" v-if="!readonly">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                        <img src="../../../assets/icon/option-del-circle.png" class="a-wh-16" @click="delStationItem(scope.$index)"  />
                    </el-tooltip>
                    <!-- <el-tooltip class="item a-ml-12" effect="dark" content="添加列表" placement="top">
                        <img src="../../../assets/icon/option-add-circle.png" class="a-wh-16" @click="addStationItem" />
                    </el-tooltip> -->
                </template>
            </el-table-column>
        </el-table>
        <electric-ammeter-add ref="ammeterAdd" @success='handleAddAmmeterSuccess' :electricProjectId='electricProjectId'></electric-ammeter-add>
    </div>
</template>

<script>
import electricAmmeterAdd from '@/views/electric/child/electric-ammeter-add'
export default {
    components: {
        electricAmmeterAdd
    },
    data () {
        return {
            ammeterInfo: '',
            optionsAmmeter: {
                url: this.$Config.apiUrl.ammeterFilter,
                method: "post",
                params: {
                    queryCompanyId: '',
                },
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "name",
                pageSize: 100
            },
        }
    },
    props: {
        tableData: {
            default: ()=>{
                return []
            }
        },
        readonly: {
            default: false,
            type: Boolean
        },
        electricProjectId: {
            default: ''
        },
        stationId: {
            default: ''
        },
        electricCompanyId: {  //电费缴纳方商户id
            default: ''
        }
    },
    computed: {
        disableAmmeter () {
            let arr = this.tableData.map(item=>{
                return item.ammeterId
            })
            return arr
        },
        showMine () {
            if(!this.stationId) {
                return true
            }else if(this.tableData.length){
                let hasMine = this.tableData[0].stationIdList.find(res=>{
                    return res.value == this.stationId
                })
                return hasMine ? false : true
            }else {
                return false
            }
        }
    },
    watch: {
        ammeterInfo: {
            handler (val) {
                if(val) {
                    this.handleChooseAmmeter(val)
                }
            }
        },
        electricCompanyId: {
            immediate: true,
            handler (val) {
                this.optionsAmmeter.params.queryCompanyId = val
            }
        }
    },
    methods: {
        handleRemoveStation (index) {
            let stationIdList = this.tableData[0].stationIdList
            stationIdList.splice(index, 1)
            let arr = this.tableData.map(item=>{
                return {
                    ...item,
                    stationIdList: stationIdList
                }
            })
            this.$emit('update:tableData', arr)
        },
        // 添加电表号
        addElectricityMeter () {
            this.$refs['ammeterAdd'].dialogVisible = true
            this.$refs['ammeterAdd'].dialogVisible = true
        },
        async handleChooseAmmeter (datas) {
            let groupId = this.tableData.length ? this.tableData[0].groupId : ''
            let result = await this.checkAmmeter(datas.id, groupId)
            if(!result) {
                return
            }

            let arr = this.tableData.map(item=>{
                return {
                    ...item,
                }
            })

            let stationIdList = arr.length ? [...arr[0].stationIdList] : []
            if(result.length) {
                // 如果存在关联的站点电表
                let stationAndAmmeter = this.handleInitAmmeter(result)
                stationAndAmmeter.map(res=>{
                    stationIdList = this.uniqueArr([...stationIdList, ...res.stationIdList])
                    res.ammeterIdList.map(item=>{
                        let hasTarget = arr.find(ite=>{
                            return ite.ammeterId == item.id
                        })
                        if(!hasTarget) {
                            arr.push({
                                stationIdList: [],
                                groupId: item.groupId,
                                ammeterId: item.id,
                                ammeterNo: item.name,
                                meterPic: item.pic ? JSON.parse(item.pic) : [],
                                ratio: ''
                            })
                        }
                        
                    })
                })
            }else {
                arr.push({
                    stationIdList: [],
                    groupId: '',
                    ammeterId: datas.id,
                    ammeterNo: datas.name,
                    meterPic: datas.pic ? JSON.parse(datas.pic) : [],
                    ratio: ''
                })
            }

            let ratioAll = 0, differenceRatio = 0
            

            // 将每一个电表的比例初始设置为100%平均分摊，保留两位小数，多余的舍弃
            let ratio = this.$decimal.decimal_except(100, arr.length)
            ratio = Math.floor(this.$decimal.decimal_ride(ratio, 100))
            ratio = this.$decimal.decimal_except(ratio, 100)

            // 计算总比列与100% 的差异值， 若存在差异值，则补充到最后一个电表
            arr.map(item=>{
                item.ratio = ratio
                item.stationIdList = stationIdList
                ratioAll = this.$decimal.decimal_add(ratioAll ,(item.ratio || 0))
            })
            differenceRatio = this.$decimal.decimal_reduce(100 ,ratioAll)
            if(differenceRatio) {
                arr[arr.length - 1].ratio = this.$decimal.decimal_add(arr[arr.length - 1].ratio ,differenceRatio)
            }
            this.ammeterInfo = ''
            this.$emit('update:tableData', arr)
        },
        async handleAddAmmeterSuccess (datas) {
            // let result = await this.checkAmmeter(datas.id)
            // if(!result) {
            //     return
            // }
            let arr = this.tableData.map(item=>{
                return {
                    ...item,
                }
            })
            let ratioAll = 0, differenceRatio = 0
            arr.push({
                stationIdList: arr.length ? [...arr[0].stationIdList] : [],
                groupId: '',
                ammeterId: datas.id,
                ammeterNo: datas.name,
                meterPic: datas.meterPic ? JSON.parse(datas.meterPic) : [],
                ratio: ''
            })

            // 将每一个电表的比例初始设置为100%平均分摊，保留两位小数，多余的舍弃
            let ratio = this.$decimal.decimal_except(100, arr.length)
            ratio = Math.floor(this.$decimal.decimal_ride(ratio, 100))
            ratio = this.$decimal.decimal_except(ratio, 100)

            // 计算总比列与100% 的差异值， 若存在差异值，则补充到最后一个电表
            arr.map(item=>{
                item.ratio = ratio
                ratioAll = this.$decimal.decimal_add(ratioAll ,(item.ratio || 0))
            })
            differenceRatio = this.$decimal.decimal_reduce(100 ,ratioAll)
            if(differenceRatio) {
                arr[arr.length - 1].ratio = this.$decimal.decimal_add(arr[arr.length - 1].ratio ,differenceRatio)
            }
            this.$emit('update:tableData', arr)
        },
        delStationItem (index) {
            let arr = this.tableData.map(item=>{
                return {
                    ...item,
                }
            })
            arr.splice(index, 1)
            
            if(arr.length) {
                let ratioAll = 0, differenceRatio = 0
                // 将每一个电表的比例初始设置为100%平均分摊，保留两位小数，多余的舍弃
                let ratio = this.$decimal.decimal_except(100, arr.length)
                ratio = Math.floor(this.$decimal.decimal_ride(ratio, 100))
                ratio = this.$decimal.decimal_except(ratio, 100)

                // 计算总比列与100% 的差异值， 若存在差异值，则补充到最后一个电表
                arr.map(item=>{
                    item.ratio = ratio
                    ratioAll = this.$decimal.decimal_add(ratioAll ,(item.ratio || 0))
                })
                differenceRatio = this.$decimal.decimal_reduce(100 ,ratioAll)
                if(differenceRatio) {
                    arr[arr.length - 1].ratio = this.$decimal.decimal_add(arr[arr.length - 1].ratio ,differenceRatio)
                }
            }
            this.$emit('update:tableData', arr)
        },
        addStationItem () {
            // let arr = this.tableData.map(item=>{
            //     return {
            //         ...item,
            //     }
            // })
            // arr.push({
            //     ammeterId: '',
            //     meterPic: [],
            //     ratio: ''
            // })
            // this.$emit('update:tableData', arr)
        },
        checkAmmeter (ammeterId, groupId = '') {
            return new Promise((resolve, reject)=>{
                this.$Axios._post({
					url: this.$Config.apiUrl.checkAmmeter,
					params: {
                        "id": ammeterId,
                        "projectId": this.electricProjectId,
                        "stationId": this.stationId,
                        "groupId": groupId
					}
				}).then(({ data }) => {
                    if(data.code == 0) {
                        resolve([])
                    }else if(data.code == 2){
                        // 该电表已关联其他站点:发多少水电费递四方速递,是否继续添加?
                        this.$confirm(data.message,'温馨提示')
                        .then(_=>{
                            resolve(data.existRelationList)
                        })
                        .catch(_=>{
                            resolve(0)
                        })
                    }else {
                        this.$message.error(data.message)
                        resolve(0)
                    }
				}).catch(err=>{
                    resolve(0)
                })
            })
        },
        handleInitAmmeter (list) {
            let stationGroup = this.groupById(list)
            let arr = Object.values(stationGroup)
            return arr.map(item=>{
                let stationIdList = []
                let ammeterIdList = []
                item.map(ite=>{
                    stationIdList.push({
                        value: ite.stationId,
                        label: ite.stationName,
                        status: ite.status
                    })
                    ammeterIdList.push({
                        id: ite.ammeterId,
                        name: ite.ammeterNumber,
                        value: ite.ammeterId,
                        label: ite.ammeterNumber,
                        pic: ite.ammeterPic,
                        groupId: ite.groupId,
                        ratio: Number((ite.ratio * 100).toFixed(2))
                    })
                })
                return {
                    stationIdList: this.uniqueArr(stationIdList),
                    ammeterIdList: this.uniqueArr(ammeterIdList),
                }
            })
        },
        groupById(arr) {
            const result = {};
            arr.forEach(item => {
                if (!result[item.groupId]) {
                result[item.groupId] = [];
                }
                result[item.groupId].push(item);
            });
            return result;
        },
        uniqueArr (arr) {
            return [...new Set(arr.map(t=>JSON.stringify(t)))].map(s=>JSON.parse(s))
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            // 只对第一列进行操作
            if (columnIndex === 0) {
                // 第一行返回 rowspan 为数据总数，colspan 为1
                if (rowIndex === 0) {
                    return {
                        rowspan: this.tableData.length,
                        colspan: 1
                    };
                } else {
                    // 其他行返回 rowspan 为0，表示不显示
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
            // 其他列保持原样
            return {
                rowspan: 1,
                colspan: 1
            };
        }
    }
}
</script>

<style lang="scss" scoped>
.send-user{
    background: #53A8FF;
    color: #ffffff;
    border-radius: 4px;
    padding: 0 10px;
    margin: 10px 10px 0px 0;
}
.send-user-tag{
    background: #ffffff;
    color: #F56C6C;
    font-size: 10px;
    padding: 0 4px;
    border-radius: 4px;
    margin-right: 6px;
    line-height: 18px;
}
</style>